import { IMarketingCampaign } from './../../models/salesforce/marketing-campaign.model';
import { SalesForceAction } from './sales-force.actions';
import { InitializerAction } from '../initializer/initiliazer.action';

export class SalesForceState {
    public attendences: Array<{
        advisors: string[],
        codRecord: string,
        noteID: string,
        subject: string,
    }>;
    public pending: boolean;
    public error: null;
    public loaded: boolean;
    public available: boolean;
    public marketingCampaigns: IMarketingCampaign;
}

export const initialState: SalesForceState = {
    attendences: [],
    pending: false,
    error: null,
    loaded: false,
    available: false,
    marketingCampaigns: null,
};

export function SalesForceReducer(state: SalesForceState = initialState, { type, payload }): SalesForceState {

    switch (type) {

        case InitializerAction.resetUserRelatedData:
            return {...state, ...{attendences: initialState.attendences, loaded: initialState.loaded }};

        case SalesForceAction.sendMarketingCampaignsData:
            return {...state, ...{ pending: true, error: null }};
        case SalesForceAction.sendMarketingCampaignsDataSuccess:
            return {...state, ...{ pending: false, marketingCampaigns: payload, error: null }};

        default:
            return state;
    }
}
